<template>
    <main>
        <Navbar />
        <div class="main">
            <div class="container">
                <div class="btn-group w-100 mb-3">
                    <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click="status = 0" :class="{'active': status == 0}">
                        <template v-if="platform == 'desktop'">Aguardando</template>
                        <template v-else>Aguar.</template>
                        <span class="badge badge-warning float-right" :class="{'w-100': platform == 'mobile', 'mt-1': platform == 'desktop'}" v-show="status == 0 && events.length > 0">{{events.length}}</span>
                        <div class="dropdown-menu">
                            <a class="dropdown-item" href="javscript:void(0);" @click="search = ''">Todos</a>
                            <a class="dropdown-item" href="javscript:void(0);" @click="search = '*'" :class="{'active': search == '*'}">Pendente</a>
                        </div>
                    </button>
                    <button type="button" class="btn btn-secondary" @click="status = 1" :class="{'active': status == 1}">
                        <template v-if="platform == 'desktop'">Encerrado</template>
                        <template v-else>Encer.</template>
                        <span class="badge badge-warning float-right" :class="{'w-100': platform == 'mobile', 'mt-1': platform == 'desktop'}" v-show="status == 1 && events.length > 0">{{events.length}}</span>
                    </button>
                    <button type="button" class="btn btn-secondary" @click="status = 3" :class="{'active': status == 3}">
                        <span>Adiado</span>
                        <span class="badge badge-warning float-right" :class="{'w-100': platform == 'mobile', 'mt-1': platform == 'desktop'}" v-show="status == 3 && events.length > 0">{{events.length}}</span>
                    </button>
                    <button type="button" class="btn btn-secondary" @click="status = 4" :class="{'active': status == 4}">
                        <template v-if="platform == 'desktop'">Cancelado</template>
                        <template v-else>Cancel.</template>
                        <span class="badge badge-warning float-right" :class="{'w-100': platform == 'mobile', 'mt-1': platform == 'desktop'}" v-show="status == 4 && events.length > 0">{{events.length}}</span>
                    </button>
                </div>
                <div class="row">
                    <div class="col" :class="{'mb-3 pr-0': platform == 'mobile'}">
                        <input class="form-control" type="text" v-model="search" placeholder="Buscar evento...">
                    </div>
                    <div class="col" :class="{'mb-3': platform == 'mobile'}">
                        <input class="form-control" type="date" v-model="date">
                    </div>
                    <div class="w-100" v-if="platform == 'mobile'"></div>
                    <div class="col" :class="{'pr-0': platform == 'mobile'}">
                        <select class="form-control mb-3" v-model="sport">
                            <option value="1" :selected="sport == 1">Futebol</option>
                            <option value="2" :selected="sport == 2">Basquete</option>
                            <option value="3" :selected="sport == 3">Lutas</option>
                            <option value="4" :selected="sport == 4">Hóquei</option>
                            <option value="5" :selected="sport == 5">Voleibol</option>
                            <option value="6" :selected="sport == 6">Tênis</option>
                            <option value="7" :selected="sport == 7">E-Sports</option>
                        </select>                        
                    </div>
                    <div class="col" @click="cancelEvents">
                        <button class="btn btn-block btn-danger" :disabled="block">
                            <i class="fas fa-ban mr-2"></i>Cancelar
                        </button>
                    </div>
                </div>
                <template v-if="warning.show || (search && !loading && filteredListEvents.length == 0)">
                    <div class="alert alert-warning" role="alert">
                        <template v-if="search">
                            <h4 class="alert-heading">Ops, nada encontrado!</h4>
                            <p class="mb-0">Não encontramos nenhum evento com o nome <strong>{{ search }}</strong>.</p>
                        </template>
                        <template v-else>
                            <h4 class="alert-heading">Atenção!</h4>
                            <p class="mb-0">{{ warning.message }}</p>
                        </template>               
                    </div>
                </template>
                <template v-else>
                    <collection-cluster data-theme="dark" v-bind="collection" :items="filteredListEvents" :style="{height: screen_innerHeight + 'px'}" :class="{'desktop pr-1': platform == 'desktop'}">
                        <div class="collection-cluster-item w-100" slot="item" slot-scope="{ cell, item }" :key="cell.index" :ref="item._id">
                            <template v-if="cell.index == 0">
                                <div class="row bg-warning p-2 m-0">
                                    <div class="col-12 text-center text-dark text-truncate">{{item.liga}}</div>
                                </div>
                            </template>
                            <template v-else-if="item['liga_id'] !== filteredListEvents[cell.index - 1]['liga_id']">
                                <div class="row bg-warning p-2 m-0">
                                    <div class="col-12 text-center text-dark text-truncate">{{item.liga}}</div>
                                </div>
                            </template>
                            <div class="row p-2 m-0" :class="{'bg-info': item.status != 0, 'bg-success': checkTimeTableEvent(item.horario)}">
                                <div class="col-auto mt-1 text-truncate text-white" :class="{'d-block w-100 text-center pt-1 pb-2 border-bottom border-secondary text-danger': platform == 'mobile'}">{{item.horario | formateDate}}</div>
                                <div class="col-auto mt-1" :class="{'no-transmission': item.transmissao_fonte == 0, 'transmission': item.transmissao_fonte != 0, 'd-block w-100 text-center pt-1 pb-2 border-bottom border-secondary': platform == 'mobile'}">
                                    <i class="fas fa-signal-stream"></i>
                                </div>
                                <div class="w-100" v-if="platform == 'mobile'"></div>
                                <div class="col mt-1 text-truncate" :class="{'d-block w-100 text-center': platform == 'mobile'}">{{item.time_casa}}</div>
                                <div class="w-100" v-if="platform == 'mobile'"></div>
                                <div class="col mt-1 text-truncate" :class="{'d-block w-100 text-center mb-1': platform == 'mobile'}">{{item.time_fora}}</div>
                                <div class="col-auto" :class="{'d-block w-100 text-center mb-2': platform == 'mobile'}">
                                    <button type="button" class="btn btn-primary btn-sm" :class="{'btn-block': platform == 'mobile'}" @click="searchByGoogle(item.time_casa, item.time_fora)">
                                        <i class="fas fa-search mr-2"></i>Pesquisar
                                    </button>
                                </div>
                                <div class="col-auto" :class="{'d-block w-100 text-center mb-2': platform == 'mobile'}">
                                    <button type="button" @click="editEvent(cell.index)" class="btn btn-secondary btn-sm" :class="{'btn-block': platform == 'mobile'}">
                                        <i class="fas fa-edit mr-2"></i>Editar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </collection-cluster>
                </template>
            </div>
        </div>
        <modal name="edit-event" :width="platform == 'desktop' ? 600 : screen_w" :height="platform == 'desktop' ? 500 : screen_h" :adaptive="true" :classes="['modal-dark','modal-edit-dark']" @before-open="modalOpen = true" @before-close="modalOpen = false">
            <template v-if="Object.keys(modalEditEvent).length">
                <header class="modal-edit-header" style="max-height: 62.06px;">
                    <div class="row">
                        <div class="col-8 text-light text-truncate text-uppercase" style="position: relative;bottom: 10px;">
                            <div class="d-flex flex-column">
                                <span class="mr-1">Atualizar evento</span>
                                <span class="text-warning text-truncate">{{ filteredListEvents[modalEditEvent.index].time_casa }} x {{ filteredListEvents[modalEditEvent.index].time_fora }}</span>
                            </div>
                        </div>
                        <div class="col-4 text-right">
                            <div class="d-flex align-items-center justify-content-end flex-wrap">
                                <button class="btn btn-sm btn-success" @click="saveEditions(modalEditEvent.index)">
                                    <template v-if="platform == 'desktop'">
                                        <i class="fas fa-save mr-2"></i>Salvar
                                    </template>
                                    <template v-else>
                                        <i class="fas fa-save"></i>
                                    </template>
                                </button>
                                <div class="modal-edit-close ml-3" role="button" @click="$modal.hide('edit-event')">
                                    <i class="fal fa-times"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
                <div class="modal-edit-scroll-area">
                    <div class="w-100">
                        <div class="card card-body rounded-0 p-3">
                            <div class="form-group">
                                <label class="text-dark" :for="`srv-id-${modalEditEvent.index}`">ID</label>
                                <input type="text" class="form-control" :id="`srv-id-${modalEditEvent.index}`" v-model="filteredListEvents[modalEditEvent.index]._id" @click="copyClipboard($event)" readonly autocomplete="off" spellcheck="false">
                            </div>
                            <div class="form-group">
                                <label class="text-dark" :for="`api-${modalEditEvent.index}`">API-ID</label>
                                <input type="number" class="form-control" :id="`api-${modalEditEvent.index}`" v-model="filteredListEvents[modalEditEvent.index].api_id" :readonly="block" autocomplete="off" spellcheck="false">
                            </div>
                            <div class="form-group">
                                <label class="text-dark" :for="`server-${modalEditEvent.index}`">Servidor</label>
                                <input type="text" class="form-control" :id="`server-${modalEditEvent.index}`" v-model="filteredListEvents[modalEditEvent.index].servidor" :readonly="block" autocomplete="off" spellcheck="false" @keyup="allowLettersAndNumbers">
                            </div>
                            <div class="form-group">
                                <label class="text-dark" :for="`streaming-id-${modalEditEvent.index}`">Transmissão</label>
                                <select class="form-control" v-model="filteredListEvents[modalEditEvent.index].transmissao_fonte" name="channels" :id="`streaming-id-${modalEditEvent.index}`" :readonly="block">
                                    <option value="1" :selected="filteredListEvents[modalEditEvent.index].transmissao_fonte == 1">Link</option>
                                    <option value="0" :selected="filteredListEvents[modalEditEvent.index].transmissao_fonte == 0">Nenhuma</option>
                                    <optgroup label="Canais de TV">
                                        <option v-for="(channel, key) in channels" :value="channel.id" :key="key" :selected="filteredListEvents[modalEditEvent.index].transmissao_fonte == channel.id">
                                            {{channel.channel}}
                                        </option>
                                    </optgroup>
                                </select>
                            </div>
                            <div class="form-group" v-show="filteredListEvents[modalEditEvent.index].transmissao_fonte == 1">
                                <label class="text-dark" :for="`streaming-link-${modalEditEvent.index}`">Link da transmissão</label>
                                <input type="text" class="form-control" :id="`streaming-link-${modalEditEvent.index}`" v-model="filteredListEvents[modalEditEvent.index].transmissao_url" :readonly="block" autocomplete="off" spellcheck="false">
                            </div>
                            <div class="form-group">
                                <label class="text-dark" :for="`situation-${modalEditEvent.index}`">Situação</label>
                                <select class="form-control" :id="`situation-${modalEditEvent.index}`" v-model="filteredListEvents[modalEditEvent.index].ativo" :disabled="block">
                                    <option value="1" :selected="filteredListEvents[modalEditEvent.index].ativo == 1">Normal</option>
                                    <option value="3" :selected="filteredListEvents[modalEditEvent.index].ativo == 3">Horário errado</option>
                                    <option value="4" :selected="filteredListEvents[modalEditEvent.index].ativo == 4">Partida suspensa</option>
                                </select>
                            </div>
                            <div class="form-group" v-show="filteredListEvents[modalEditEvent.index].ativo == 1 || filteredListEvents[modalEditEvent.index].ativo == 3">
                                <label class="text-dark" :for="`date-${modalEditEvent.index}`">Data do evento</label>
                                <input type="date" class="form-control" :id="`date-${modalEditEvent.index}`" v-model="filteredListEvents[modalEditEvent.index].data" :readonly="block" autocomplete="off" spellcheck="false">
                            </div>
                            <div class="form-group" v-show="filteredListEvents[modalEditEvent.index].ativo == 1 || filteredListEvents[modalEditEvent.index].ativo == 3">
                                <label class="text-dark" :for="`hour-${modalEditEvent.index}`">Hora do evento</label>
                                <input type="time" class="form-control" :id="`hour-${modalEditEvent.index}`" v-model="filteredListEvents[modalEditEvent.index].hora" :readonly="block" autocomplete="off" spellcheck="false">
                            </div>
                            <div class="form-group" v-show="filteredListEvents[modalEditEvent.index].atualizado_por">
                                <label class="text-dark" :for="`update-to-${modalEditEvent.index}`">Atualizado por</label>
                                <input type="text" class="form-control" :id="`update-to-${modalEditEvent.index}`" :value="filteredListEvents[modalEditEvent.index].atualizado_por" readonly autocomplete="off" spellcheck="false">
                            </div>
                            <ul class="nav nav-tabs" :id="`myTab-${modalEditEvent.index}`" role="tablist">
                                <li class="nav-item">
                                    <a class="nav-link active" :id="`full-time-tab-${modalEditEvent.index}`" data-toggle="tab" :href="`#full-time-${modalEditEvent.index}`" role="tab" :aria-controls="`full-time-${modalEditEvent.index}`" aria-selected="true">
                                        {{ filteredListEvents[modalEditEvent.index].esporte != '1' ? 'Resultado final' : '90 minutos'}}
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" :class="{'disabled': filteredListEvents[modalEditEvent.index].esporte != '1'}" :id="`first-time-tab-${modalEditEvent.index}`" data-toggle="tab" :href="`#first-time-${modalEditEvent.index}`" role="tab" :aria-controls="`first-time-${modalEditEvent.index}`" aria-selected="false">1º tempo</a>
                                </li>                                             
                            </ul>
                            <div class="tab-content mt-2" :id="`myTabContent-${modalEditEvent.index}`">
                                <div class="tab-pane fade show active" :id="`full-time-${modalEditEvent.index}`" role="tabpanel" :aria-labelledby="`full-time-tab-${modalEditEvent.index}`">
                                    <div class="form-group">
                                        <template v-if="filteredListEvents[modalEditEvent.index].esporte == '1'">
                                            <label class="text-dark" :for="`score-home-90-${modalEditEvent.index}`">Placar casa (<b>90</b>)</label>
                                            <select class="form-control" :id="`score-home-90-${modalEditEvent.index}`" v-model="filteredListEvents[modalEditEvent.index].placar_casa_90">
                                                <option v-for="i in 21" :value="i-1" :key="i-1" :selected="filteredListEvents[modalEditEvent.index].placar_casa_90 == 0">{{i-1}}</option>
                                            </select>
                                        </template>
                                        <template v-else-if="filteredListEvents[modalEditEvent.index].esporte == '3'">
                                            <label class="text-dark" :for="`score-home-90-${modalEditEvent.index}`">Resultado <b>{{filteredListEvents[modalEditEvent.index].time_casa}}</b></label>
                                            <select class="form-control" :id="`score-home-90-${modalEditEvent.index}`" v-model="filteredListEvents[modalEditEvent.index].placar_casa_90">
                                                <option value="0" :selected="filteredListEvents[modalEditEvent.index].placar_casa_90 == 0">0</option>
                                                <option value="1" :selected="filteredListEvents[modalEditEvent.index].placar_casa_90 == 1">1</option>
                                            </select>
                                        </template>
                                        <template v-else>
                                            <label class="text-dark" :for="`score-home-90-${modalEditEvent.index}`">Placar <b>{{filteredListEvents[modalEditEvent.index].time_casa}}</b></label>
                                            <input class="form-control" type="number" :id="`score-home-90-${modalEditEvent.index}`" v-model="filteredListEvents[modalEditEvent.index].placar_casa_90">
                                        </template>
                                    </div>
                                    <div class="form-group">
                                        <template v-if="filteredListEvents[modalEditEvent.index].esporte == '1'">
                                            <label class="text-dark" :for="`score-away-90-${modalEditEvent.index}`">Placar fora (<b>90</b>)</label>
                                            <select class="form-control" :id="`score-away-90-${modalEditEvent.index}`" v-model="filteredListEvents[modalEditEvent.index].placar_fora_90">
                                                <option v-for="i in 21" :value="i-1" :key="i-1" :selected="filteredListEvents[modalEditEvent.index].placar_fora_90 == 0">{{i-1}}</option>
                                            </select>
                                        </template>
                                        <template v-else-if="filteredListEvents[modalEditEvent.index].esporte == '3'">
                                            <label class="text-dark" :for="`score-home-90-${modalEditEvent.index}`">Resultado <b>{{filteredListEvents[modalEditEvent.index].time_fora}}</b></label>
                                            <select class="form-control" :id="`score-home-90-${modalEditEvent.index}`" v-model="filteredListEvents[modalEditEvent.index].placar_fora_90">
                                                <option value="0" :selected="filteredListEvents[modalEditEvent.index].placar_fora_90 == 0">0</option>
                                                <option value="1" :selected="filteredListEvents[modalEditEvent.index].placar_fora_90 == 1">1</option>
                                            </select>
                                        </template>
                                        <template v-else>
                                            <label class="text-dark" :for="`score-away-90-${modalEditEvent.index}`">Placar <b>{{filteredListEvents[modalEditEvent.index].time_fora}}</b></label>
                                            <input class="form-control" type="number" :id="`score-away-90-${modalEditEvent.index}`" v-model="filteredListEvents[modalEditEvent.index].placar_fora_90">
                                        </template>
                                    </div>
                                    <template v-if="filteredListEvents[modalEditEvent.index].esporte == '1' && filteredListEvents[modalEditEvent.index].escanteios > 0">
                                        <div class="form-group">
                                            <label class="text-dark" :for="`corners-home-${modalEditEvent.index}`">Escanteios (<b>CASA</b>)</label>
                                            <input class="form-control" type="number" :id="`corners-home-${modalEditEvent.index}`" v-model="filteredListEvents[modalEditEvent.index].escanteios_casa">
                                        </div>
                                        <div class="form-group">
                                            <label class="text-dark" :for="`corners-away-${modalEditEvent.index}`">Escanteios (<b>FORA</b>)</label>
                                            <input class="form-control" type="number" :id="`corners-away-${modalEditEvent.index}`"  v-model="filteredListEvents[modalEditEvent.index].escanteios_fora">
                                        </div>
                                    </template>
                                    <template v-if="filteredListEvents[modalEditEvent.index].esporte == '1' && filteredListEvents[modalEditEvent.index].cartoes > 0">
                                        <div class="form-group">
                                            <label class="text-dark" :for="`cards-home-${modalEditEvent.index}`">Cartões (<b>CASA</b>)</label>
                                            <input class="form-control" type="number" :id="`cards-home-${modalEditEvent.index}`" v-model="filteredListEvents[modalEditEvent.index].cartoes_casa">
                                        </div>
                                        <div class="form-group">
                                            <label class="text-dark" :for="`cards-away-${modalEditEvent.index}`">Cartões (<b>FORA</b>)</label>
                                            <input class="form-control" type="number" :id="`cards-away-${modalEditEvent.index}`" v-model="filteredListEvents[modalEditEvent.index].cartoes_fora">
                                        </div>
                                    </template>
                                    <template v-if="filteredListEvents[modalEditEvent.index].esporte == '1' && filteredListEvents[modalEditEvent.index].ao_vivo == 'sim'">
                                        <div class="form-group">
                                            <label class="text-dark" :for="`gols-timeline-${modalEditEvent.index}`">Gols timeline</label>
                                            <input class="form-control" type="text" :id="`gols-timeline-${modalEditEvent.index}`" v-number-only v-model="filteredListEvents[modalEditEvent.index].gols_timeline" autocomplete="off" spellcheck="false">
                                        </div>
                                    </template>
                                    <template v-if="filteredListEvents[modalEditEvent.index].esporte == '1' && filteredListEvents[modalEditEvent.index].jogadores.length > 0">
                                        <div class="form-group">
                                            <label class="text-white bg-secondary w-100 p-2 rounded">Jogador - <b>Primeiro Gol</b></label>
                                            <div class="form-check" v-for="(jogador, i) in filteredListEvents[modalEditEvent.index].jogadores" :value="jogador.player" :key="i">
                                                <input class="form-check-input" type="radio" :name="`player-f-${modalEditEvent.index}`" :value="jogador.player" :id="`player-f-${jogador.player}`" @change="selectPlayer($event, i, 1)" :ref="`player-f-${jogador.player}`">
                                                <label class="form-check-label text-dark" :for="`player-f-${jogador.player}`">{{jogador.player}}</label>
                                            </div>
                                            <div class="form-check">
                                                <input class="form-check-input" type="radio" value="***" id="player-First-No players available" @change="selectPlayer($event, 1, 1)">
                                                <label class="form-check-label text-dark" for="player-First-No players available">Nenhum jogador disponível</label>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="text-white bg-secondary w-100 p-2 rounded">Jogador - <b>Fez gol</b></label>
                                            <div class="form-check" v-for="(jogador, i) in filteredListEvents[modalEditEvent.index].jogadores" :value="jogador.player" :key="i">
                                                <input class="form-check-input" type="checkbox" :value="jogador.player" :id="`player-${jogador.player}`" @change="selectPlayer($event, i, 2)" :ref="`player-${jogador.player}`">
                                                <label class="form-check-label text-dark" :for="`player-${jogador.player}`">{{jogador.player}}</label>
                                            </div>
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox" value="---" id="player-No players available" @change="selectPlayer($event, 1, 2)">
                                                <label class="form-check-label text-dark" for="player-No players available">Nenhum jogador disponível</label>
                                            </div>
                                        </div>
                                        <div class="row" :class="{'d-contents w-100': platform == 'mobile'}" v-if="!block">
                                            <div class="col" :class="{'mb-3 p-0': platform == 'mobile'}">
                                                <button class="btn btn-sm btn-block btn-primary" @click="editListPlayers(filteredListEvents[modalEditEvent.index])"><i class="fas fa-edit mr-2"></i>Editar jogadores</button>
                                            </div>
                                            <div class="col mb-3" :class="{'p-0 mt-3': platform == 'mobile'}">
                                                <button class="btn btn-sm btn-block btn-warning" @click="deleteListPlayers(filteredListEvents[modalEditEvent.index])">
                                                    <i class="fas fa-trash mr-2"></i>Limpar jogadores
                                                </button>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                                <div class="tab-pane fade" :id="`first-time-${modalEditEvent.index}`" role="tabpanel" :aria-labelledby="`first-time-tab-${modalEditEvent.index}`">
                                    <div class="form-group" v-if="filteredListEvents[modalEditEvent.index].esporte == '1'">
                                        <label class="text-dark" :for="`score-home-pt-${modalEditEvent.index}`">Placar casa (<b>PT</b>)</label>
                                        <select class="form-control" :id="`score-home-pt-${modalEditEvent.index}`" v-model="filteredListEvents[modalEditEvent.index].placar_casa_pt">
                                            <option v-for="i in 21" :value="i-1" :key="i-1" :selected="filteredListEvents[modalEditEvent.index].placar_casa_pt == 0">{{i-1}}</option>
                                        </select>
                                    </div>
                                    <div class="form-group" v-if="filteredListEvents[modalEditEvent.index].esporte == '1'">
                                        <label class="text-dark" :for="`score-away-pt-${modalEditEvent.index}`">Placar fora (<b>PT</b>)</label>
                                        <select class="form-control" :id="`score-away-pt-${modalEditEvent.index}`" v-model="filteredListEvents[modalEditEvent.index].placar_fora_pt">
                                            <option v-for="i in 21" :value="i-1" :key="i-1" :selected="filteredListEvents[modalEditEvent.index].placar_fora_pt == 0">{{i-1}}</option>
                                        </select>
                                    </div>                                                    
                                </div>
                            </div>
                            <div class="form-group" v-if="!block">
                                <label class="text-dark" :for="`update-${modalEditEvent.index}`">Atualizar automaticamente</label>
                                <select class="form-control" v-model="filteredListEvents[modalEditEvent.index].automatico" :id="`update-${modalEditEvent.index}`" :disabled="block">
                                    <option value="1" :selected="filteredListEvents[modalEditEvent.index].automatico == 1">Sim</option>
                                    <option value="2" :selected="filteredListEvents[modalEditEvent.index].automatico == 2">Não</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label class="text-dark" :for="`status-${modalEditEvent.index}`">Status do evento</label>
                                <template v-if="filteredListEvents[modalEditEvent.index].ativo == 4">
                                    <input class="form-control" value="Cancelado" type="text" readonly>
                                    <input class="form-control" :value="filteredListEvents[modalEditEvent.index].status = 4" type="hidden">
                                </template>
                                <template v-else>
                                    <select class="form-control" :id="`status-${modalEditEvent.index}`" v-model="filteredListEvents[modalEditEvent.index].status">
                                        <option value="0" :selected="filteredListEvents[modalEditEvent.index].status == 0">Aguardando</option>
                                        <option value="1" :selected="filteredListEvents[modalEditEvent.index].status == 1">Encerrado</option>
                                        <option value="3" :selected="filteredListEvents[modalEditEvent.index].status == 3">Adiado</option>
                                        <option value="4" :selected="filteredListEvents[modalEditEvent.index].status == 4">Cancelado</option>
                                    </select>
                                </template>
                            </div>
                            <div class="row" :class="{'d-contents w-100': platform == 'mobile'}">
                                <div class="col" :class="{'mb-3 p-0': platform == 'mobile'}">
                                    <button class="btn btn-block btn-success" @click="saveEditions(modalEditEvent.index)"><i class="fas fa-save mr-2"></i>Salvar alterações</button>
                                </div>
                                <div class="col" :class="{'p-0': platform == 'mobile'}">
                                    <button class="btn btn-block btn-danger" @click="$modal.hide('edit-event')">
                                        <i class="fas fa-ban mr-2"></i>Cancelar
                                    </button>
                                </div>
                                <div class="col" :class="{'p-0 mt-3': platform == 'mobile'}" v-if="!block">
                                    <button class="btn btn-block btn-secondary" @click="deleteEvent(filteredListEvents[modalEditEvent.index])">
                                        <i class="fas fa-trash mr-2"></i>Excluir
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div><!--/scroll-->
            </template>
        </modal><!-- /modal-edit-event-->
        <modal name="edit-players" :width="platform == 'desktop' ? 600 : screen_w" :height="platform == 'desktop' ? 500 : screen_h" :adaptive="true" :classes="['modal-dark','modal-edit-dark']" @before-open="modalOpen = true" @before-close="modalOpen = false">
            <template v-if="Object.keys(modal).length">
                <header class="modal-edit-header">
                    <div class="row">
                        <div class="col-8 text-light text-uppercase">Editar jogadores</div>
                        <div class="col-4 text-right">
                            <div class="modal-edit-close ml-3" role="button" @click="$modal.hide('edit-players')">
                                <i class="fal fa-times"></i>
                            </div>
                        </div>
                    </div>
                </header>
                <div class="modal-edit-scroll-area">
                    <div class="container h-100">
                        <div class="row">
                            <div class="col text-center text-warning text-truncate">{{modal.time_casa}}</div>
                            <div class="col-auto text-center text-warning">
                                <i class="fal fa-times"></i>
                            </div>
                            <div class="col text-center text-warning text-truncate">{{modal.time_fora}}</div>
                        </div>
                        <template v-if="Object.keys(selectedPlayersList).length">
                            <div class="row rw" v-for="(item, index) in selectedPlayersList" :key="index">
                                <div class="col-8">
                                    <input type="text" v-model="item.jogador" class="form-control" autocomplete="off" spellcheck="false">
                                </div>
                                <div class="col-4">
                                    <button class="btn btn-block btn-danger" @click="removePlayerInList(index, item.jogador)">
                                        <i class="fas fa-trash"></i>
                                    </button>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="d-flex justify-content-center align-items-center h-100">
                                <div class="text-white">Sem jogadores</div>
                            </div>
                        </template>
                    </div>
                </div>
            </template>
        </modal>
      <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>
    </main>
</template>

<script>
import Vue from 'vue'
import {api} from '../api'
import Navbar from './Navbar'
import Swal from 'sweetalert2'
import VModal from 'vue-js-modal'
import moment from 'moment-timezone'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import CollectionCluster from 'vue-collection-cluster'

Vue.use(VModal)

const today = moment().tz('America/Recife').format('YYYY-MM-DD');

const heightAdjustMobile = 260;
const heightAdjustDesktop = 200;
const heightAdjust = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? heightAdjustMobile : heightAdjustDesktop;

export default {
    data() {
        return {
            sport: 1,
            status: 0,
            events: [],
            search: '',
            block: true,
            date: today,
            loading: false,
            warning: {
                show: false,
                message: ''
            },
            collection: {
                heightType: 'automatic',
                // itemHeight: 46
            },
            modal: {},
            channels: [],
            modalOpen: false,
            modalEditEvent: {},
            selectedPlayersList: {},
            screen_w: window.screen.width,
            screen_h: window.screen.height,
            screen_innerHeight: window.innerHeight - heightAdjust,
            platform: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? 'mobile' : 'desktop',
            network_erros: {
				0: {
					message: 'Não há conexão com a internet!'
                },
                401: {
                    message: 'Você não tem autorização para realizar essa operação!'
                },
				404: {
					message: 'Página solicitada não foi encontrada!'
				},
				500: {
					message: 'O servidor está passando por problemas técnicos!'
				},
				408: {
					message: 'Por favor, verifique sua conexão de rede e tente novamente!'
				}					
			}
        }
    },
    components: {
        Navbar,
        Loading,
        CollectionCluster
    },
    methods: {
        cancelEvents() {

            const self = this;

            Swal.fire({
                title: 'Cancelar eventos',
                html: 'Você deseja mesmo cancelar todos os eventos?',
                showCancelButton: true,
                confirmButtonColor: '#28a745',
                cancelButtonColor: '#d33',
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Sim'
            }).then((result) => {

                if (result.value) {

                    self.loading = true;

                    api.post('cancel-events', {
                        date: self.date,
                        sport: self.sport
                    }).then((response) => {
                        switch(response.data.result) {
                            case 'success':
                                Swal.fire(
                                    'Parabéns!',
                                    'Todos os eventos foram cancelados!',
                                    'success'
                                );
                            break;
                            default:
                                Swal.fire(
                                    'Atenção',
                                    response.data.message,
                                    'warning'
                                );
                            break;
                        }
                    }).catch((error) => {
                        try {
                            Swal.fire(
                                'Falha',
                                self.network_erros[error.status]['message'],
                                'warning'
                            );
                        } catch(e) {
                            Swal.fire(
                                'Falha',
                                self.network_erros[408]['message'],
                                'warning'
                            );
                        }
                    }).finally(() => {
                        self.loading = false;
                    });
                }
            });            
        },
        listEvents() {

            const self = this;

            self.events = [];
            self.loading = true;
            self.modalEditEvent = {};
            self.warning.show = false;

            api.get(`eventos/${self.date}/${self.sport}/resultados/${self.status}`).then((response) => {
                switch(response.data.result) {
                    case 'success':
                        self.channels = response.data.channels.sort((a, b) => {

                            if (self.removeAccents(a.channel) < self.removeAccents(b.channel)) return -1;
                            if (self.removeAccents(a.channel) > self.removeAccents(b.channel)) return 1;

                            return 0;
                        });
                        self.events = response.data.events.sort((a, b) => {

                            if (self.removeAccents(a.liga) < self.removeAccents(b.liga)) return -1;
                            if (self.removeAccents(a.liga) > self.removeAccents(b.liga)) return 1;

                            if (a.horario < b.horario) return -1;
                            if (a.horario > b.horario) return 1;

                            return 0;
                        });
                    break;
                    case 'nothing_found':
                        self.warning.show = true;
                        self.warning.message = 'Nenhum evento disponível';
                    break;
                    default:
                        self.warning.show = true;
                        self.warning.message = response.data.message;
                    break;
                }
            }).catch((error) => {
                try {
                    self.warning.show = true;
                    self.warning.message = self.network_erros[error.status]['message'];
                } catch(e) {
                    self.warning.show = true;
                    self.warning.message = self.network_erros[408]['message'];
                }
            }).finally(() => {
                self.loading = false;
            });            
        },
        saveEditions(index) {
            
            try {

                let html = ``;

                const self = this;
                const event = self.filteredListEvents[index];

                self.$modal.hide('edit-event');

                if (event.api_id.toString().trim() == '') {
                    Swal.fire(
                        'Atenção!',
                        'Informe a API-ID do evento',
                        'warning'
                    );
                }  else if (event.data.toString().trim() == '') {
                    Swal.fire(
                        'Atenção!',
                        'Informe a data do evento!',
                        'warning'
                    );
                } else if (event.hora.toString().trim() == '') {
                    Swal.fire(
                        'Atenção!',
                        'Informe a hora do evento!',
                        'warning'
                    );
                } else if (event.placar_casa_90.toString().trim() == '') {
                    Swal.fire(
                        'Atenção!',
                        event.esporte == '1' ? 'Informe o placar casa (<b>90</b>)' : `Informe o placar de <b>${event.time_casa}</b>`,
                        'warning'
                    );
                } else if (event.placar_fora_90.toString().trim() == '') {
                    Swal.fire(
                        'Atenção!',
                        event.esporte == '1' ? 'Informe o placar fora (<b>90</b>)' : `Informe o placar de <b>${event.time_fora}</b>`,
                        'warning'
                    );
                } else if (event.placar_casa_pt.toString().trim() == '') {
                    Swal.fire(
                        'Atenção!',
                        'Informe o placar casa (<b>PT</b>)',
                        'warning'
                    );
                } else if (event.placar_fora_pt.toString().trim() == '') {
                    Swal.fire(
                        'Atenção!',
                        'Informe o placar fora (<b>PT</b>)',
                        'warning'
                    );
                } else if (event.escanteios_casa.toString().trim() == '') {
                    Swal.fire(
                        'Atenção!',
                        'Informe os escanteios do time da casa',
                        'warning'
                    );
                } else if (event.escanteios_fora.toString().trim() == '') {
                    Swal.fire(
                        'Atenção!',
                        'Informe os escanteios do time de fora',
                        'warning'
                    );
                } else if (event.cartoes_casa.toString().trim() == '') {
                    Swal.fire(
                        'Atenção!',
                        'Informe os cartões do time da casa',
                        'warning'
                    );
                } else if (event.cartoes_fora.toString().trim() == '') {
                    Swal.fire(
                        'Atenção!',
                        'Informe os cartões do time de fora',
                        'warning'
                    );
                } else if (event.jogadores.length > 0 && self.selectedPlayersList.length == 0) {
                    Swal.fire(
                        'Atenção!',
                        'Informe os jogadores que fizeram gol no jogo',
                        'warning'
                    );
                } else if (event.gols_timeline == '' && event.ao_vivo == 'sim' && (event.placar_casa_90 > 0 || event.placar_fora_90 > 0)) {
                    Swal.fire(
                        'Atenção!',
                        'Informe o tempo que os gols saíram',
                        'warning'
                    );
                } else {
                   
                    let cartoes_casa = parseInt(event.cartoes_casa);
                    let cartoes_fora = parseInt(event.cartoes_fora);
                    let escanteios_casa = parseInt(event.escanteios_casa);
                    let escanteios_fora = parseInt(event.escanteios_fora);
                    let gols_timeline = self.getGolsTimeline(event.gols_timeline);

                    Object.values(self.selectedPlayersList).forEach(item => {
                        html += `
                        <div class="row m-0 pl-0 pt-2 pb-2 border-bottom">
                            <div class="col pl-0 text-truncate text-left">${item.jogador}</div>
                            <div class="col-auto text-center">
                                <i class="fas fa-futbol text-success"></i>
                            </div>
                            <div class="col pr-0 text-truncate text-right">${item.momento} - <span class="text-uppercase">(${item.time.slice(0,3)})</span></div>
                        </div>
                        `;
                    });

                    Swal.fire({
                        title: 'Salvar alterações',
                        html: `
                            Você deseja mesmo salvar as alterações do evento? <p class="mb-0"><b>${event.time_casa}</b> X <b>${event.time_fora}</b></p> 
                            <hr />
                            <center>
                                <b class="text-info">Placar</b>
                            </center>
                            <div class="row m-0 pl-0 pt-2 pb-2 border-bottom">
                                <div class="col pl-0 text-left">90 minutos</div>
                                <div class="col pr-0 text-right">${event.placar_casa_90}-${event.placar_fora_90}</div>
                            </div>
                            <div class="row m-0 pr-0 pt-2 pb-2 border-bottom mb-3">
                                <div class="col pl-0 text-left">Primeiro tempo</div>
                                <div class="col pr-0 text-right">${event.placar_casa_pt}-${event.placar_fora_pt}</div>
                            </div>
                            <center>
                                <b class="text-info">Estatísticas</b>
                            </center>
                            <div class="row m-0 pl-0 pt-2 pb-2 border-bottom">
                                <div class="col pl-0 text-left">Gols</div>
                                <div class="col pr-0 text-right">${gols_timeline || 'Sem informações'}</div>
                            </div>
                            <div class="row m-0 pl-0 pt-2 pb-2 border-bottom">
                                <div class="col pl-0 text-left">Cartões</div>
                                <div class="col pr-0 text-right">${cartoes_casa + cartoes_fora}</div>
                            </div>
                            <div class="row m-0 pr-0 pt-2 pb-2 border-bottom mb-3">
                                <div class="col pl-0 text-left">Escanteios</div>
                                <div class="col pr-0 text-right">${escanteios_casa +  escanteios_fora}</div>
                            </div>
                            ${html == '' ? '' : `
                                <center>
                                    <b class="text-info">Jogadores</b>
                                </center>
                                ${html}
                            `}
                        `,
                        showCancelButton: true,
                        confirmButtonColor: '#28a745',
                        cancelButtonColor: '#d33',
                        cancelButtonText: 'Cancelar',
                        confirmButtonText: 'Sim'
                    }).then((result) => {

                        if (result.value) {

                            self.loading = true;

                            event.estatisticas = {
                                gols: gols_timeline,
                                cartoes: {
                                    total: cartoes_casa + cartoes_fora,
                                    total_casa: cartoes_casa,
                                    total_fora: cartoes_fora
                                },
                                escanteios: {
                                    total: escanteios_casa + escanteios_fora,
                                    total_casa: escanteios_casa,
                                    total_fora: escanteios_fora
                                },
                                jogadores: Object.values(self.selectedPlayersList).map((obj) => {
                                    return obj
                                })
                            };

                            api.post('resultado', {
                                evento: event
                            }).then((response) => {
                                switch(response.data.result) {
                                    case 'success':
                                        Swal.fire(
                                            'Parabéns!',
                                            'As alterações foram salvas com sucesso!',
                                            'success'
                                        );
                                    break;
                                    default:
                                        Swal.fire(
                                            'Atenção',
                                            response.data.message,
                                            'warning'
                                        );
                                    break;
                                }
                            }).catch((error) => {
                                try {
                                    Swal.fire(
                                        'Falha',
                                        self.network_erros[error.status]['message'],
                                        'warning'
                                    );
                                } catch(e) {
                                    Swal.fire(
                                        'Falha',
                                        self.network_erros[408]['message'],
                                        'warning'
                                    );
                                }
                            }).finally(() => {
                                self.loading = false;
                            });
                        }
                    });
                }
            }
            catch(e)
            {
                Swal.fire(
                    'Atenção!',
                    'O evento não está disponível, atualize a página e tente novamente!',
                    'warning'
                );
            }
        },
        deleteEvent(event) {

            try {

                const self = this;

                self.$modal.hide('edit-event');
                self.$modal.hide('edit-players');

                Swal.fire({
                    title: 'Confirmação',
                    html: `Você deseja mesmo excluir o evento? <hr /> <p class="font-weight-bold">${event.time_casa} X ${event.time_fora}</p> <hr /> Lembrando que após a confirmação, esse evento será excluído definitivamente.`,
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Sim'
                }).then((result) => {

                    if (result.value) {

                        self.loading = true;

                        api.delete(`delete-event/${event._id}`).then((response) => {
                            switch(response.data.result) {
                                case 'success':
                                    Swal.fire(
                                        'Parabéns!',
                                        'O evento foi excluído com sucesso',
                                        'success'
                                    );
                                break;
                                default:
                                    Swal.fire(
                                        'Atenção',
                                        response.data.message,
                                        'warning'
                                    );
                                break;
                            }
                        }).catch((error) => {
                            try {
                                Swal.fire(
                                    'Falha',
                                    self.network_erros[error.status]['message'],
                                    'warning'
                                );
                            } catch(e) {
                                Swal.fire(
                                    'Falha',
                                    self.network_erros[408]['message'],
                                    'warning'
                                );
                            }
                        }).finally(() => {
                            self.loading = false;
                        });
                    }
                });
            } 
            catch(e) 
            {
                Swal.fire(
                    'Falha',
                    e.message,
                    'error'
                );
            }
        },
        selectPlayer(event, index, momento) {

            const jogador = event.target.value;

            if (jogador == '***') {
                this.selectedPlayersList = {};
            }

            window.console.log(this.selectedPlayersList)
            if (momento == 1) {
                this.$set(this.selectedPlayersList, '1st Goal', {
                    id: index,
                    time: '---',
                    tipo: '---',
                    tempo: '---',
                    momento: '1st Goal',
                    jogador: jogador
                });
            } else if (event.target.checked) {
                this.$set(this.selectedPlayersList, jogador, {
                    id: index,
                    time: '---',
                    tipo: '---',
                    tempo: '---',
                    momento: 'Goal',
                    jogador: jogador
                });
            } else if (this.selectedPlayersList[jogador] == undefined) {
                for (let key in this.selectedPlayersList) {
                    let playerItem = this.selectedPlayersList[key];
                    if (jogador.toString().includes(playerItem.jogador)) {
                        this.$delete(this.selectedPlayersList, playerItem.id);
                        break;
                    }
                }
            } else {
                this.$delete(this.selectedPlayersList, jogador);
            }
        },
        editEvent(index) {
            try {
                this.modalEditEvent = {index};
                this.$modal.show('edit-event');
                this.$modal.hide('edit-players');

                const event = this.filteredListEvents[index];

                if (this.modalOpen && event) {
                    setTimeout(() => this.getSelectPlayer(event), 1000);
                }
            } catch(e) {
                // window.console.log(e.message);
            }
        },
        getSelectPlayer(event) {

            this.selectedPlayersList = {};

            try {

                if (Object.keys(this.selectedPlayersList).length == 0) {

                    for (const item of event.estatisticas.jogadores) {

                        this.$set(this.selectedPlayersList, item.id, {
                            id: item.id,
                            time: item.time,
                            tipo: item.tipo,
                            tempo: item.tempo,
                            momento: item.momento,
                            jogador: item.jogador
                        });

                        for (let k in this.$refs) {
                            if (k.includes(item.jogador)) {
                                if (item.jogador !== '---') {
                                    if (item.momento == '1st Goal') {
                                        document.getElementById(k).checked = true;
                                    } else if (document.getElementById(k).type == 'checkbox') {
                                        document.getElementById(k).checked = true;
                                    }
                                }  
                            }
                        }
                    }
                }
            } catch(e) {
                // window.console.log(e.message);
            }
        },
        editListPlayers(item) {
            try {
                this.modal = item;
                this.$modal.hide('edit-event');
                this.$modal.show('edit-players');
            } catch(e) {
                Swal.fire(
                    'Falha',
                    e.message,
                    'error'
                );
            }
        },
        removePlayerInList(id, player) {
            try {

                const inputs = document.querySelectorAll('input:checked');

                if (this.selectedPlayersList[id] != undefined) {

                    this.$delete(this.selectedPlayersList, id);

                    if (inputs.length) {
                        inputs.forEach((element) => {
                            if (element.value.includes(player)) {
                                element.checked = false;
                            }
                        });
                    }
                } else if (this.selectedPlayersList[player] != undefined) {

                    this.$delete(this.selectedPlayersList, player);

                    if (inputs.length) {
                        inputs.forEach((element) => {
                            if (element.value.includes(player)) {
                                element.checked = false;
                            }
                        });
                    }
                } else {
                    Swal.fire(
                        'Falha',
                        'Não é possível remover esse jogador da lista',
                        'error'
                    );
                }
            } catch(e) {
                Swal.fire(
                    'Falha',
                    e.message,
                    'error'
                );
            }
        },
        deleteListPlayers(item) {
            try {
                Swal.fire({
                    title: 'Confirmação',
                    html: `Você deseja mesmo excluir a lista de jogadores? <hr /> <p class="font-weight-bold">${item.time_casa} X ${item.time_fora}</p>`,
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Sim'
                }).then((result) => {

                    if (result.value) {

                        this.selectedPlayersList = {};

                        const inputs = document.querySelectorAll('input:checked');

                        if (inputs.length) {
                            inputs.forEach((element) => {
                                element.checked = false
                            });
                        }
                    }
                });
            } catch(e) {
                Swal.fire(
                    'Falha',
                    e.message,
                    'error'
                );
            }
        },
        searchByGoogle(team_home, team_away) {
            window.open(`https://google.com/search?q=${encodeURIComponent(`${team_home} x ${team_away}`)}`, '_blank');
        },
        removeAccents(str) {
            
            let string = str;
            let map = {a : /[\xE0-\xE6]/g, A : /[\xC0-\xC6]/g, e : /[\xE8-\xEB]/g, E : /[\xC8-\xCB]/g, i : /[\xEC-\xEF]/g, I : /[\xCC-\xCF]/g, o : /[\xF2-\xF6]/g, O : /[\xD2-\xD6]/g, u : /[\xF9-\xFC]/g, U : /[\xD9-\xDC]/g, c : /\xE7/g, C : /\xC7/g, n : /\xF1/g, N : /\xD1/g};

            for (let key in map) {
                 let rex = map[key];
                 string = string.replace(rex, key);
            }

            return string;
        },
        allowLettersAndNumbers(event) {
            event.target.value = event.target.value.replace(/[^a-zA-Z0-9]+/gi,'');
        },
        allowLettersAndNumbersChar(event) {
            event.target.value = event.target.value.replace(/[^A-Za-z0-9/._-]+/gi,'');
        },
        copyClipboard(event) {
            navigator.clipboard.writeText(event.target.value).then(() => {
                Swal.fire(
                    'Parabéns!',
                    'O <strong>ID</strong> foi copiado com sucesso!',
                    'success'
                )
            }, () => {
                Swal.fire(
                    'Erro!',
                    'Não foi possível copiar o <strong>ID</strong>!',
                    'error'
                )
            });            
        },
        getGolsTimeline(gols) {
            if (Array.isArray(gols)) {
                return gols;
            } else {
                if (gols.includes(',')) {
                    return gols.split(',');
                } else {
                    return [gols];
                }
            }
        },
        checkTimeTableEvent(timetable) {
            const actual_timetable = moment().tz('America/Recife').format();
            const event_timetable = moment(timetable).tz('America/Recife').add(2, 'hours').add(15, 'minutes').format();
            return actual_timetable >= event_timetable;
        }
    },
    watch: {
        date() {
            this.listEvents();
        },
        sport() {
            this.listEvents();
        },
        status() {
            this.listEvents();
        },
        modalOpen(value) {
            try {
                var body = document.getElementsByTagName('body')[0];

                if (value) {
                    body.classList.add('overflow-hidden');
                } else {
                    this.modal = {};
                    this.modalEditEvent = {};
                    body.classList.remove('overflow-hidden');
                }
            } catch(e) {
                window.console.log(e.message);
            }
        }
    },
    filters: {
        formateDate(date) {
            return moment(date).tz('America/Recife').format('DD/MM HH:mm');
        }
    },
    computed: {
        filteredListEvents() {
            return this.events.filter((item) => {
                return this.removeAccents(item.liga).toLowerCase().trim().includes(this.removeAccents(this.search).toLowerCase().trim()) || this.removeAccents(item.time_casa).toLowerCase().trim().includes(this.removeAccents(this.search).toLowerCase().trim()) || this.removeAccents(item.time_fora).toLowerCase().trim().includes(this.removeAccents(this.search).toLowerCase().trim()) || this.removeAccents(item.contexto).toLowerCase().trim().includes(this.removeAccents(this.search).toLowerCase().trim())
            });
        }
    },
    directives: {
        numberOnly: {
            bind: (el) => {
                el.handler = () => {
                    el.value = el.value.replace(/[^a-zA-Z0-9-,]/g,"");
                }
                el.addEventListener('input', el.handler)
            },
            unbind: (el) => {
                el.removeEventListener('input', el.handler)
            }
        }
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.platform = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? 'mobile' : 'desktop';
        });
    },
    beforeMount() {
        try {
            const {pipe} = JSON.parse(localStorage.getItem('auth'));
            this.block = pipe == 1 ? false : true;
        } catch(e) {
            this.block = false;
        }
    },
    created() {
        this.listEvents()
    }
}
</script>

<style scoped>
.modal-dark {
  background-color: rgb(51, 51, 51);
  text-align: left;
  border-radius: 3px;
  padding: 0;
}
.modal-dark.bg-brown {
  background-color: #3b3b3b !important
}
.modal-dark .modal-edit-header {
  width: 100%;
  padding: 1em;
  background-color: #222;
}
.modal-edit-dark .container .row,
.modal-edit-dark .container .row .w-100 .row,
.modal-edit-dark .container .row .col-12 .row {
  padding: .6em;
  background-color: #333;
}
.modal-edit-dark .container .row:nth-of-type(odd),
.modal-edit-dark .container .row:nth-of-type(odd) .row:not(.rw),
.modal-edit-dark .container .row .col-12:nth-of-type(odd) .row {
  background-color: #444;
}
.modal-edit-scroll-area {
    width: 100%;
    padding-bottom: 10px;
    overflow: hidden auto;
    height: calc(100% - 56px);
}
.modal-edit-scroll-area::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    background: #4b4b4b;
    border-radius: 0;
}
.modal-edit-scroll-area::-webkit-scrollbar-thumb {
    background: #373737;
    border-radius: 0;
}
.modal-dark .modal-edit-scroll-area {
    background-color: #222;
}
.modal-edit-close {
    color: #fff;
}
.modal-edit-close:hover {
    color: #ddd;
}
.drop-left {
    margin-left: -100%!important;
}
.v--modal-overlay {
  z-index: 99999999!important;
}
.mw-0 {
    max-width: 0!important;
}
.collection-cluster {
    overflow-x: auto;
}
.collection-cluster.desktop::-webkit-scrollbar {
  width: 9px;
  height: 9px;
}
.collection-cluster.desktop::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}
.collection-cluster.desktop::-webkit-scrollbar-thumb {
  background: #e1e1e1;
  border: 0px none #ffffff;
  border-radius: .25rem;
}
.collection-cluster.desktop::-webkit-scrollbar-thumb:hover {
  background: #ffffff;
}
.collection-cluster.desktop::-webkit-scrollbar-thumb:active {
  background: #ddd;
}
.collection-cluster.desktop::-webkit-scrollbar-track {
  background: #666666;
  border: 0px none #ffffff;
  border-radius: .25rem;
}
.collection-cluster.desktop::-webkit-scrollbar-track:hover {
  background: #666666;
}
.collection-cluster.desktop::-webkit-scrollbar-track:active {
  background: #333333;
}
.collection-cluster.desktop::-webkit-scrollbar-corner {
  background: transparent;
}
.collection-cluster[data-theme="dark"] .row .col {
    color: #fff;
}
.collection-cluster[data-theme="dark"] .collection-cluster-item {
    vertical-align: top;
    border-top: 1px solid #454d55;
}
.collection-cluster[data-theme="dark"] .collection-cluster-item {
    background-color: #343a40;
}
.collection-cluster[data-theme="dark"] .collection-cluster-item:nth-of-type(odd) .row:not(.bg-warning) {
    background-color: rgba(255,255,255,.05);
}
.collection-cluster[data-theme="dark"] .collection-cluster-item .row:not(.bg-danger) .col-auto.transmission .fas.fa-signal-stream {
    color: #dc3545;
}
.collection-cluster[data-theme="dark"] .collection-cluster-item .row.bg-danger .col-auto.no-transmission .fas.fa-signal-stream,
.collection-cluster[data-theme="dark"] .collection-cluster-item .row:not(.bg-danger) .col-auto.no-transmission .fas.fa-signal-stream {
    color: #fff;
}
.collection-cluster .collection-cluster-item .collapse .card {
    height: 300px;
    max-height: 300px;
    overflow-x: auto;
}
</style>